































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import topTitle from "@/components/faceCoupon/topTitle.vue";
import topStep from "@/components/faceCoupon/topStep.vue";

const faceIntegralMemberModule = namespace("faceIntegral");
@Component({
  components: {
    topStep,
    topTitle
  }
})
export default class FaceIntegralMember extends Vue {
  @faceIntegralMemberModule.State("detailData") detailData!: any;
  titleName: string = "面对面积分";
  /* 步骤 */
  stepsArry: Object = [
    { num: 1, name: "查询会员", class: "active" },
    { num: 2, name: "确认身份", class: "active" },
    { num: 3, name: "为会员积分", class: "" },
    { num: 4, name: "完成", class: "" }
  ]; 
  count: number = 0;
  finished: boolean = false;
  defaultImg :any = require("@/image/default.png");

  mounted() {
    this.getDetails();
  }
  getDetails() {
    this.$store.dispatch("faceIntegral/getMemberDetailData", {
      searchText: this.$route.query.val,
      searchType: this.$route.query.type
    });
  }
  nextIntegral() {
    this.$router.push({
      path: '/faceIntegral/IntegralRecording',
      query: {
        
      }
    });
  }
}
